
import Vue from "vue"

const types = ["normal", "info", "success", "warning", "error"]

export default Vue.extend({
  name: "CripNoticeContent",

  props: {
    description: { type: String },
    icons: { type: Object },
    title: { type: String, required: true },
    type: { type: String, required: true },
  },

  computed: {
    withIcon(): boolean {
      return this.type !== "normal"
    },

    withDesc(): boolean {
      return !!this.description
    },
  },
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NoticeContent.vue